<template>
  <div class="user-cards">
    <div class="cards-img">
      <img src="~@/assets/images/cards/american-express.svg" alt="kromnix logo" width="30">
      <img src="~@/assets/images/cards/mastercard.png" alt="kromnix logo" width="50" style="margin:0px 10px;">
      <img src="~@/assets/images/cards/visa.png" alt="kromnix logo" width="30">
    </div>
    <div class="cards-number">
      <RadioGroup v-if="rfpsPayments.length" vertical class="cards-number-group" v-model="defaultPayment" @on-change="handleOnChangeDefault">
        <Radio :label="card.id" class="card-info-wrap" v-for="(card, idx) in rfpsPayments" :key="idx">
          <Row class="card-info">
            <i-col>{{ card.account_number || card.card_number | maskNumber }}</i-col>
            <i-col>
              {{ card.expiry_date }}
              <Icon type="ios-trash-outline" color="#ed4014" @click="handleDeleteCard(card.id)"/>
            </i-col>
          </Row>
        </Radio>
      </RadioGroup>
      <Spin size="small" fix v-if="isLoading"></Spin>
      <Button type="text" style="margin-top:20px" @click="handleAddPayment">Add new payment method</Button>
    </div>
    <PaymentMethodForm ref="PaymentMethodForm" @reload="getRfpsPayments"/>
  </div>
</template>

<script>
import { fetchPaymentMethods, deletePaymentMethod, setDefaultPaymentMethod } from '@/services/payments'
import PaymentMethodForm from '@/components/payments/PaymentMethodForm'

export default {
  components: {
    PaymentMethodForm
  },

  data () {
    return {
      rfpsPayments: [],
      defaultPayment: null,
      isLoading: false
    }
  },

  filters: {
    maskNumber (num) {
      var re = new RegExp(/(\b[\dX][-. \dX]+(\d{4}.?\d?)\b)/)
      const match = num.match(re)

      if (match) {
        const orig = match[1]
        const end = match[2]
        let hidden = orig.substr(0, orig.length - end.length)

        hidden = hidden.replace(/\S/g, '*') + end
        num = num.replace(orig, hidden)
      }

      return num
    }
  },

  mounted () {
    this.getRfpsPayments()
  },

  methods: {
    getRfpsPayments () {
      this.isLoading = true
      fetchPaymentMethods().then(res => {
        if (res.data.results.length) {
          this.rfpsPayments = res.data.results
          const dPay = res.data.results.findIndex(item => item.is_default === true)
          if (dPay > -1) this.defaultPayment = res.data.results[dPay].id
        } else {
          this.rfpsPayments = []
          this.defaultPayment = null
        }
        this.isLoading = false
      }).catch(err => {
        console.log('Failed to fetch rfps payments: ', err)
        this.isLoading = false
      })
    },

    handleAddPayment () {
      this.$refs.PaymentMethodForm.openModal()
    },

    handleDeleteCard (id) {
      this.isLoading = true
      deletePaymentMethod(id).then(res => {
        this.isLoading = false
        this.$Message.success({
          background: true,
          duration: 3,
          content: 'Payment method successfully deleted'
        })
        this.getRfpsPayments()
      }).catch(err => {
        console.log('Failed to delete a payment method: ', err)
        this.isLoading = false
      })
    },

    handleOnChangeDefault (val) {
      setDefaultPaymentMethod(val).then(res => {
      }).catch(err => {
        console.log('Failed to set default payment method: ', err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.user-cards {
  .cards-img {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cards-number {
    .cards-number-group {
      width: 100%;
      .card-info-wrap {
        display: flex;
        align-items: center;
        .card-info {
          width: 100%;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
}
</style>
